import React, { useState, useEffect } from 'react';
import './PasswordGate.css';

interface PasswordGateProps {
  children: React.ReactNode;
}

const PasswordGate: React.FC<PasswordGateProps> = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if already authenticated in this session
    const auth = sessionStorage.getItem('authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch('/api/auth/verify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (data.success) {
        sessionStorage.setItem('authenticated', 'true');
        setIsAuthenticated(true);
      } else {
        setError('Falsches Passwort');
        setPassword('');
      }
    } catch (err) {
      setError('Verbindungsfehler');
    } finally {
      setIsLoading(false);
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="password-gate">
      <div className="password-gate-overlay"></div>
      <div className="password-gate-container">
        <div className="password-gate-card">
          <div className="password-gate-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <h1>Zugang erforderlich</h1>
          <p>Bitte geben Sie das Passwort ein, um fortzufahren.</p>
          
          <form onSubmit={handleSubmit}>
            <div className="password-input-wrapper">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort eingeben..."
                autoFocus
                disabled={isLoading}
              />
            </div>
            
            {error && <div className="password-error">{error}</div>}
            
            <button type="submit" disabled={isLoading || !password}>
              {isLoading ? 'Prüfe...' : 'Einloggen'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;
